import { useConsentStore } from "@/state/ConsentStore";
import { useState } from "react";
import { Button, Text } from "@peerbots/core";
import FaceLogo from "@/assets/static/Peerbots152.png";

export default function RequestTrackingPopup({
  forceShow = false,
}: {
  forceShow?: boolean;
}) {
  const consentToAnalytics = useConsentStore(
    (state) => state.consentToAnalytics,
  );
  const changeConsentToAnalytics = useConsentStore(
    (state) => state.changeConsentToAnalytics,
  );

  const [sessionDismissed, setSessionDismissed] = useState(false);
  const [randomlySelected] = useState(() => Math.random() < 0.1);

  const isTesting =
    typeof navigator !== "undefined" &&
    (navigator.userAgent.includes("peerbots-pa11y-ci") ||
      navigator.webdriver ||
      (typeof window !== "undefined" &&
        (window as unknown as { __VITEST_BROWSER__?: boolean })
          .__VITEST_BROWSER__));

  const showPopup =
    forceShow ||
    (!isTesting &&
      !consentToAnalytics &&
      randomlySelected &&
      !sessionDismissed);

  return (
    <>
      {/* Ask about 10% of visits if the user has not consented to analytics */}
      {showPopup && (
        <div className="fixed z-50 bottom-2 right-2 sm:bottom-10 sm:right-10 w-96 m-2 p-3 rounded-md shadow-md border border-slate-700 text-sm bg-white">
          <img
            src={FaceLogo}
            className="w-12 h-12 mx-auto"
            alt="Peerbots Logo"
          ></img>
          <Text>
            Can we track the features you use so we can more effectively{" "}
            <Text as="span" className="italic inline">
              build social robots for everyone
            </Text>
            ?
          </Text>
          <Button
            variant="secondary"
            size="sm"
            className="inline-block mt-4 mx-2"
            onClick={() => {
              changeConsentToAnalytics(false);
              setSessionDismissed(true);
            }}
          >
            No, maybe another time.
            {/* , I prefer to use Peerbots privately. */}
          </Button>
          <Button
            variant="primary"
            size="sm"
            className="inline-block mt-4 mx-2"
            onClick={() => changeConsentToAnalytics(true)}
          >
            Yes, I&apos;d like to help!
          </Button>
        </div>
      )}
    </>
  );
}
